import { UserManager } from 'oidc-client';
const env = window._env_;

const config = {
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 600,
  authority: env.OIDC_AUTHORIY,
  client_id: env.OIDC_CLIENT,
  client_secret: env.OIDC_SECRET,
  redirect_uri: env.REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile email PF IdentityServerApi offline_access',
  post_logout_redirect_uri: env?.LOGOUT_REDIRECT_URI,
  // silent_redirect_uri: `${env?.LOGOUT_REDIRECT_URI}silent-renew.html`,
};

export const userManager = new UserManager(config);
